import gql from "graphql-tag";

const CONCRETE_SHIPMENT_REPORT_QUERY = gql`
  query ConcreteShipmentQuery($code: String!) {
    concreteShipmentByCode(code: $code) {
      id
      code
      startTime
      loadingStartTime
      loadingEndTime
      travelStartTime
      waterCut
      quantity
      shipmentInfo {
        contractCode
        constructionName
        equipmentCode
        equipmentPlate
        operatorName
      }
      concreteFormula {
        id
        code
        fck
        concreteFamily {
          gravelType
          slump {
            id
            description
          }
        }
      }
      shipmentMaterials {
        id
        inventoryItemId
        inventoryItem {
          name
        }
        humidityMeasurement {
          value
        }
        shipmentMaterialLocations {
          formulaWeight
          inventoryLocation {
            id
            name
          }
        }    
      }
      inventoryChanges {
        inventoryLocation {
          id
        }
        quantity
        manualOperation {
          id
        }
      } 
    }
  }
`;

export default CONCRETE_SHIPMENT_REPORT_QUERY;
